import React, { useState, Fragment } from 'react'
import { Flex, Box } from 'reflexbox'

import { SemiTitle, Text } from 'components/Typography'
import Modal from 'components/v2/Modal'
import Button from 'components/Button'
import Loader from 'components/Loader'
import { Close } from 'components/Icons'

import { deletePlansGiftCard, deleteValueGiftCard } from 'services/giftCards'

const CreateGiftCardTypeModal = ({ isOpen, onRequestClose, card }) => {
  const [status, setStatus] = useState(null)

  const requestClose = () => {
    setStatus(null)
    onRequestClose()
  }

  const handleDelete = async () => {
    try {
      setStatus('loading')
      card?.plans ? await deletePlansGiftCard(card?.origin_id) : await deleteValueGiftCard(card?.origin_id)
      setStatus('success')
    } catch (e) {
      console.log(e)
      setStatus('error')
    }
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={requestClose}>
      <Flex flexDirection='column' minWidth={588}>
        {['error', 'success'].includes(status) ? (
          <Fragment>
            <Flex mb={16} justifyContent='space-between'>
              <SemiTitle>Excluir Cartão</SemiTitle>
              <Button size='smallest' variant='ghost' onClick={requestClose}>
                <Close />
              </Button>
            </Flex>
            <Text>
              {status === 'success'
                ? 'Cartão excluído com sucesso!'
                : 'Ocorreu uma falha ao excluir  o cartão, por favor tente novamente.'}
            </Text>
          </Fragment>
        ) : (
          <Fragment>
            <Box mb={16}>
              <SemiTitle>Excluir Cartão</SemiTitle>
            </Box>
            <Text>Tem certeza que deseja excluir este cartão presente?</Text>
            <Flex justifyContent='flex-end' mt={32}>
              <Button variant='tertiary' outlined type='button' onClick={requestClose} mr={24}>
                Cancelar
              </Button>
              <Button variant='tertiary' disabled={status === 'loading'} onClick={handleDelete}>
                {status === 'loading' ? <Loader /> : 'Excluir'}
              </Button>
            </Flex>
          </Fragment>
        )}
      </Flex>
    </Modal>
  )
}

export default CreateGiftCardTypeModal
